(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npShareUrlButton', [function () {
        return {
            restrict: 'E',
            controller: ['$scope', '$timeout', 'browserService', controller],
            scope: {
                url: '=',
                name: '=',
                imgUrl: '=?',
                addClass: '=?',
                title: '=?'
            },
            templateUrl: '/app/shared/shareURL/shareUrl.html',
            transclue: true,
            controllerAs: 'vm'
        };
    }]);

    function controller($scope, $timeout, browserService) {
        var vm = this;
        vm.translation = globalResources;

        vm.tooltip = $scope.title ? $scope.title : vm.translation.CopyUserFriendlyUrl;
        
        vm.getShareLink = getShareLink;
        vm.imgUrl = $scope.imgUrl ? $scope.imgUrl : ' ';
        vm.additionClass = $scope.addClass ? $scope.addClass : 'shareurl-button';

        vm.getShareLink = getShareLink;
        vm.BROWSER_TYPE = BrowserType;
        vm.browserType = browserService.detectBrowserWindow();

        function getShareLink(event) {  
            event.currentTarget.classList.add('opacity-0-5');         
            
            var shareLink = '<a href="' + $scope.url + '" target="_blank" style="font-family: Calibri, sans-serif; font-size: 16px; text-decoration: underline; color: blue">' + $scope.name + '</a>';
            $('#html-container').text(shareLink);
            var htmlEditor = CodeMirror.fromTextArea(document.getElementById('html-container'), {
                mode: 'text/html'
            });
            var cm = $('.CodeMirror')[0].CodeMirror;
            $(cm.getWrapperElement()).hide();
            copyFormatted(htmlEditor.getValue());
            $timeout(function () {
                event.currentTarget.classList.remove('opacity-0-5');
                $scope.$apply();
            }, 5000, false);
        }
        function copyFormatted(html) {
            // Create an iframe (isolated container) for the HTML
            var container = document.createElement('div');
            container.innerHTML = html;

            // Hide element
            container.style.position = 'fixed';
            container.style.pointerEvents = 'none';
            container.style.opacity = 0;

            // Mount the iframe to the DOM to make `contentWindow` available
            document.body.appendChild(container);

            // Copy to clipboard
            window.getSelection().removeAllRanges();

            var range = document.createRange();
            range.selectNode(container);
            window.getSelection().addRange(range);

            //copy selected dom
            document.execCommand('copy');

            // Remove the iframe
            document.body.removeChild(container);
        }
    }

})();